import type { Ctx } from './ctx';

/**
 * Come useState, ma per ciò che cambia «dove sono» dentro una pagina (elemento aperto, scheda scelta):
 * ogni cambio entra nella cronologia, quindi «indietro» e «avanti» del browser lo ripristinano.
 */
export function useNavState<T>(ctx: Ctx, key: string, initial: T): [T, (value: T) => void] {
  const value = key in ctx.sub ? (ctx.sub[key] as T) : initial;
  return [value, (next: T) => ctx.setSub({ [key]: next })];
}
